"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importStar(require("react"));
const context_1 = require("../../../context");
const videoStyles_1 = require("../../../styling/videoStyles");
const styles_1 = tslib_1.__importDefault(require("./styles"));
/**
 * Configurable Icon Button component (for an icon button).
 */
const ButtonIcon = (0, react_1.forwardRef)(({ active = true, children, activeClass = "video-button--on lv-button--on", inactiveClass = "video-button--off lv-button--off", classes = {}, classNames = "", disabled = false, icon, label = "Default Button", onClick, style = {}, id, activeId, inActiveId, ...props }, ref) => {
    var _a, _b, _c, _d;
    const playerCtx = (0, react_1.useContext)(context_1.PlayerUiContext);
    const encoderCtx = (0, react_1.useContext)(context_1.EncoderUiContext);
    let getStyles;
    if (encoderCtx) {
        getStyles = (0, styles_1.default)((_a = encoderCtx === null || encoderCtx === void 0 ? void 0 : encoderCtx.mobileDevice) !== null && _a !== void 0 ? _a : false);
    }
    else {
        getStyles = (0, styles_1.default)((_b = playerCtx === null || playerCtx === void 0 ? void 0 : playerCtx.mobileDevice) !== null && _b !== void 0 ? _b : false);
    }
    const mergedClasses = (0, videoStyles_1.useStyles)({ source: classes, target: getStyles }, "videoIconButton");
    let loweredLabel;
    if (typeof label !== "undefined") {
        loweredLabel = label.replace(/\s+/g, "-").toLowerCase();
    }
    return (react_1.default.createElement("button", { "aria-label": label, className: `${mergedClasses.root} ${active ? activeClass !== null && activeClass !== void 0 ? activeClass : "" : inactiveClass !== null && inactiveClass !== void 0 ? inactiveClass : ""} ${classNames && classNames}`, "data-icon-button": (_d = (_c = icon === null || icon === void 0 ? void 0 : icon.props) === null || _c === void 0 ? void 0 : _c.iconName) !== null && _d !== void 0 ? _d : "", "data-selenium": `${label && loweredLabel}-button`, disabled: disabled, onClick: onClick !== null && onClick !== void 0 ? onClick : undefined, ref: ref, type: "button", title: label, id: id, "data-active-state-id": active ? activeId : inActiveId, ...props }, icon != null && icon));
});
ButtonIcon.displayName = "ButtonIcon";
exports.default = ButtonIcon;
//# sourceMappingURL=index.js.map